import { gql, useClient } from 'urql';

import { useQueryParams } from '@/hooks';
import { downloadFile, mapVariables } from '@/utils';
import {
  PlayerTransactionsReportQuery,
  PlayerTransactionsReportQueryVariables,
} from './__generated__/usePlayerTransactionsReport';
import { queryParams } from './queryParams';

const PLAYER_TRANSACTIONS_REPORT_QUERY = gql`
  query PlayerTransactionsReport(
    $id: String
    $rawId: String
    $playerId: ID
    $brand: BrandEnum
    $gameRoundId: String
    $minAmount: PositiveBigDecimal
    $maxAmount: PositiveBigDecimal
    $from: OffsetDateTime
    $to: OffsetDateTime
    $currency: String
    $paymentStatus: [PaymentStatus!]
    $paymentMethod: String
    $transactionTypes: [TransactionType!]
    $adjustmentType: AdjustmentType
    $adjustmentCategory: AdjustmentCategory
    $orderBy: TransactionSearchOrder
    $desc: Boolean
    $before: String
    $after: String
    $first: Int
    $last: Int
  ) {
    viewer {
      id
      exportedTransactionsV2(
        id: $id
        rawId: $rawId
        playerId: $playerId
        brand: $brand
        gameRoundId: $gameRoundId
        minAmount: $minAmount
        maxAmount: $maxAmount
        from: $from
        to: $to
        currency: $currency
        paymentStatus: $paymentStatus
        transactionTypes: $transactionTypes
        paymentMethod: $paymentMethod
        adjustmentType: $adjustmentType
        adjustmentCategory: $adjustmentCategory
        orderBy: $orderBy
        desc: $desc
        before: $before
        after: $after
        first: $first
        last: $last
      ) {
        url
      }
    }
  }
`;

export default function usePlayerTransactionsReport(playerId: string) {
  const [query] = useQueryParams(queryParams);
  const client = useClient();

  const generate = async () => {
    const variables: PlayerTransactionsReportQueryVariables = {
      ...mapVariables(query),
      playerId,
    };

    return client
      .query<
        PlayerTransactionsReportQuery,
        PlayerTransactionsReportQueryVariables
      >(PLAYER_TRANSACTIONS_REPORT_QUERY, variables)
      .toPromise()
      .then(async (res) => {
        const url = res.data?.viewer.exportedTransactionsV2.url;

        if (url) {
          await downloadFile(url, {
            fileName: 'player-transactions-report.csv',
          });
        }
      });
  };

  return {
    generate,
  };
}
